module.exports = __webpack_public_path__ + "media/images/common/header/station-0e63cbc58380400555e358b69c663175.svg";